/* eslint-disable no-unused-vars */

import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HiTranslate } from "react-icons/hi";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useIntl } from "react-intl";
import {
  Nav,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardTitle,
  CardBody,
} from "reactstrap";
import { userLogoutAsync } from "../../actions/auth-async.action";
import { setSidebarBg, setTheme } from "../../actions/settings.action";
import whiteLogoIcon from "../../assets/images/w-logo.png";
import { localeContext } from "../../App";
import profilephoto from "../../assets/images/user.png";
import {
  customerUpdateDataService,
  customerUpdateService,
} from "../../services/customer.service";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import PrivatePageVerification from "../../components/private.page.verification";
import iconLightIcon from "../../assets/images/mini-w-logo.png";

const Header = () => {
  /*
   * Private Page Token Verification Module.
   */
  const auth_obj = useSelector((state) => state.auth);
  const { loginBy } = auth_obj;
  const { userId } = auth_obj.user;
  const dispatch = useDispatch();
  PrivatePageVerification();
  /* ----------------------- */

  //Language translator handler
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const settings = useSelector((state) => state.settings);
  const {
    user: { name, isActive, subscriptionStatus, theme, isFilledDataSheet },
  } = auth_obj;
  const [locale, setLocale] = useContext(localeContext);
  const [modal, setModal] = useState(false);
  const [isRemind, setIsRemind] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isLanguage, setIsLanguage] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleMenu = () => setDropdownOpen((prevState) => !prevState);

  useEffect(() => {
    dispatch(setTheme(theme));
    dispatch(setSidebarBg(theme === "dark" ? "skin6" : "skin1"));
    async function fetchData() {
      if (!isFilledDataSheet && location.pathname !== "/datasheets/data") {
        setModal(true);
        setModalText("disclaimerText");
      }
    }
    fetchData();
  }, [dispatch, userId, theme]);

  const toggle = () => setIsOpen(!isOpen);

  const showMobilemenu = () => {
    document.getElementById("main-wrapper").classList.toggle("show-sidebar");
  };
  const sidebarHandler = () => {
    let element = document.getElementById("main-wrapper");
    switch (settings.activeSidebarType) {
      case "full":
      case "iconbar":
        element.classList.toggle("mini-sidebar");
        if (element.classList.contains("mini-sidebar")) {
          element.setAttribute("data-sidebartype", "mini-sidebar");
        } else {
          element.setAttribute("data-sidebartype", settings.activeSidebarType);
        }
        break;

      case "overlay":
      case "mini-sidebar":
        element.classList.toggle("full");
        if (element.classList.contains("full")) {
          element.setAttribute("data-sidebartype", "full");
        } else {
          element.setAttribute("data-sidebartype", settings.activeSidebarType);
        }
        break;
      default:
    }
  };

  const handleLogout = () => {
    dispatch(userLogoutAsync());
    navigate("/");
  };

  const handleSetlanguage = (e) => {
    setIsLanguage(!isLanguage);
    handleChangeLanguage(e);
  };

  const handleChangeLanguage = async (e) => {
    setLocale(e);
    const customer = {
      id: userId,
      language: e?.target?.value,
    };
    await customerUpdateService(customer);
  };

  const updateTheme = async () => {
    const { data } = await customerUpdateDataService({
      _id: userId,
      theme: settings.activeTheme === "dark" ? "light" : "dark",
      loginBy,
    });

    dispatch(setTheme(data.theme));
    dispatch(setSidebarBg(theme === "dark" ? "skin6" : "skin1"));
  };

  const goToMembers = (e) => {
    e.preventDefault();
    navigate(`/datasheets/data?id=${userId}`);
    setModal("");
  };

  const handleRemind = (e) => {
    e.preventDefault();
    setModalText("reminderText");
    setIsRemind(true);
  };

  const Disclaimer = () => {
    return (
      <>
        {modal && (
          <div className="position-fixed w-100 h-100 card-wrapper">
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100 px-3 card-overlay">
              <Card className="shadow" style={{ maxWidth: "500px" }}>
                <CardTitle className="p-3 bg-success">
                  <h5 className="m-0 text-center text-white">
                    {t("disclaimer")}
                  </h5>
                </CardTitle>
                <CardBody>
                  <p className="text-muted">{modalText && t(modalText)}</p>
                  <div>
                    {!isRemind ? (
                      <>
                        <button
                          className="btn btn-outline-cGreen mr-1 "
                          onClick={goToMembers}
                        >
                          {t("updateUserData")}
                        </button>
                        <button
                          className="btn btn-outline-cGreen"
                          onClick={handleRemind}
                        >
                          {t("remindMeLater")}
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-outline-cGreen"
                        onClick={() => setModal("")}
                      >
                        {t("ok")}
                      </button>
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <header
        className="topbar navbarbg header"
        data-navbarbg={settings?.activeNavbarBg}
      >
        <Navbar
          container={false}
          className={
            "px-0 top-navbar " +
            (settings?.activeNavbarBg === "skin6"
              ? "navbar-light"
              : "navbar-dark")
          }
          expand="md"
        >
          <div
            className="navbar-header"
            id="logobg"
            data-logobg={settings?.activeLogoBg}
          >
            {/*--------------------------------------------------------------------------------*/}
            {/* Mobile View Toggler  [visible only after 768px screen]                         */}
            {/*--------------------------------------------------------------------------------*/}
            <span
              className="nav-toggler d-block d-md-none"
              onClick={showMobilemenu.bind(null)}
            >
              <i className="ti-menu ti-close" />
            </span>
            {/*--------------------------------------------------------------------------------*/}
            {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
            {/*--------------------------------------------------------------------------------*/}
            <NavbarBrand href="/">
              {/* Sidebar mini logo */}
              <b className="logo-icon">
                <img src={iconLightIcon} alt="homepage" className="mini-logo" />
              </b>
              <span className="logo-text">
                <img
                  src={whiteLogoIcon}
                  alt="homepage"
                  className="header-logo"
                />
              </span>
            </NavbarBrand>
            {/*--------------------------------------------------------------------------------*/}
            {/* Mobile View Toggler  [visible only after 768px screen]                         */}
            {/*--------------------------------------------------------------------------------*/}
            <span
              className="topbartoggler d-block d-md-none"
              onClick={toggle.bind(null)}
            >
              <i className="ti-more" />
            </span>
          </div>
          <Collapse
            className="navbarbg"
            isOpen={isOpen}
            navbar
            data-navbarbg={settings?.activeNavbarBg}
          >
            <Nav className="float-left" navbar>
              <NavItem>
                <NavLink
                  href="#"
                  className="d-none d-md-block"
                  onClick={sidebarHandler.bind(null)}
                >
                  <i className="mdi mdi-menu" />
                </NavLink>
              </NavItem>
            </Nav>
            <h3 className="text-white mt-2 welcome-text">
              <strong>
                {t("welcome")} {name}
              </strong>
            </h3>
            <Nav className="ml-auto float-right" navbar>
              <div className="align-self-center">
                <h6 className="text-white mb-0 ml-3 pr-2">
                  <strong>
                    {t("accountStatus")} :{" "}
                    {isActive &&
                    ["active", "trialing", "approved"].includes(
                      subscriptionStatus,
                    ) ? (
                      <span className="ml-2 text-white">{t("active")}</span>
                    ) : (
                      <span className="text-danger ml-2">{t("disable")}</span>
                    )}
                  </strong>
                </h6>
              </div>
              {/*--------------------------------------------------------------------------------*/}
              {/* Start Profile Dropdown                                                         */}
              {/*--------------------------------------------------------------------------------*/}
              <Dropdown
                isOpen={dropdownOpen}
                toggle={toggleMenu}
                direction={"down"}
              >
                <DropdownToggle caret nav className="pro-pic">
                  <img
                    src={profilephoto}
                    alt="user"
                    className="rounded-circle"
                    width="31"
                  />
                </DropdownToggle>
                <DropdownMenu end={true} className="user-dd">
                  <span className="with-arrow">
                    <span className="bg-primary" />
                  </span>
                  <div className="d-flex no-block align-items-center p-3 mb-2 welcome-box">
                    <div className="">
                      <img
                        src={profilephoto}
                        alt="user"
                        className="rounded-circle"
                        width="60"
                      />
                    </div>
                    <div className="ml-2">
                      <p className="m-0 text-white">{t("welcome")}</p>
                      <h4 className="mb-0 text-white">{name}</h4>
                    </div>
                  </div>
                  <DropdownItem tag={Link} to="/account/security">
                    <i className="ti-settings mx-1" /> {t("accountSettings")}
                  </DropdownItem>
                  <div className="py-2 px-3">
                    <div
                      className="cursor-pointer d-flex justify-content-between align-items-center"
                      onClick={() => setIsLanguage(!isLanguage)}
                    >
                      <div>
                        <HiTranslate className="mx-1 translate-icon" /> Select
                        Language
                      </div>
                      {isLanguage ? (
                        <MdKeyboardArrowUp />
                      ) : (
                        <MdKeyboardArrowDown />
                      )}
                    </div>
                    <Collapse isOpen={isLanguage}>
                      <DropdownItem
                        onClick={() => {
                          handleSetlanguage("en");
                        }}
                      >
                        <p className="ml-3 m-0">English</p>
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          handleSetlanguage("es");
                        }}
                      >
                        <p className="ml-3 m-0">Spanish</p>
                      </DropdownItem>
                    </Collapse>
                  </div>
                  <DropdownItem onClick={updateTheme}>
                    <i
                      className={`${
                        settings?.activeTheme === "dark"
                          ? "far fa-moon"
                          : "fas fa-sun"
                      } mx-1`}
                    />{" "}
                    {t("darkTheme")}:{" "}
                    {settings?.activeTheme === "dark" ? "On" : "Off"}
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={handleLogout}>
                    <i className="fa fa-power-off mr-1 ml-1" /> {t("logout")}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {/*--------------------------------------------------------------------------------*/}
              {/* End Profile Dropdown                                                           */}
              {/*--------------------------------------------------------------------------------*/}
            </Nav>
          </Collapse>
        </Navbar>
      </header>
      <Disclaimer />
    </>
  );
};

export default Header;
